export default {
  PAGE__WORKING: 'Just a moment ...'
}
